/**
 * Iter-60 — `useIsMobile`
 *
 * Returns `true` on viewports narrower than the Tailwind `md:` breakpoint
 * (768px). Uses `matchMedia` under the hood so it responds live to
 * device rotation, DevTools resize, and window-drag on desktop.
 */
import { useEffect, useState } from "react";

export const MOBILE_BREAKPOINT_PX = 768;

export function useIsMobile(breakpoint = MOBILE_BREAKPOINT_PX) {
  const q = `(max-width: ${breakpoint - 1}px)`;
  const get = () =>
    typeof window !== "undefined" && window.matchMedia
      ? window.matchMedia(q).matches
      : false;
  const [isMobile, setIsMobile] = useState(get);
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mql = window.matchMedia(q);
    const handler = (e) => setIsMobile(e.matches);
    // Safari <14 uses addListener/removeListener.
    if (mql.addEventListener) mql.addEventListener("change", handler);
    else mql.addListener(handler);
    setIsMobile(mql.matches);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", handler);
      else mql.removeListener(handler);
    };
  }, [q]);
  return isMobile;
}

export default useIsMobile;
